module.exports = __webpack_public_path__ + "img/93.7b64368a.jpg";